export const DEFAULT_BUSINESS_LOCATION_NAME = 'IRENES WIGS - NEW YORK';

const normalize = (value) => String(value || '')
  .toUpperCase()
  .replace(/[^A-Z0-9]+/g, '');

export const locationToAddress = (location) => {
  if (!location) return null;
  return {
    id: location.id || location.locid || location.loc_id,
    name: location.name || location.loc_location || '',
    addr1: location.addr1 || location.address1 || location.loc_addr_1 || '',
    addr2: location.addr2 || location.address2 || location.loc_addr_2 || '',
    addr3: location.addr3 || location.address3 || location.loc_addr_3 || '',
    city: location.city || location.loc_city || '',
    state: location.state || location.loc_state || '',
    zip: location.zip || location.loc_zip || '',
    country: location.country || location.loc_country || '',
    phone: location.phone || location.loc_cust_1 || '',
    email: location.email || location.loc_cust_2 || '',
    website: location.website || location.loc_cust_3 || '',
    instagram: location.instagram || location.loc_instagram || '',
    facebook: location.facebook || location.loc_facebook || '',
    customPlatform: location.customPlatform || location.loc_custom_platform || '',
    customAddress: location.customAddress || location.loc_custom_address || '',
  };
};

export const findBusinessAddress = (locations = []) => {
  const configuredName = process.env.REACT_APP_BUSINESS_LOCATION_NAME
    || DEFAULT_BUSINESS_LOCATION_NAME;
  const match = locations.find((location) => (
    normalize(location?.name || location?.loc_location) === normalize(configuredName)
  ));
  return locationToAddress(match);
};

export const getBusinessAddressLines = (address = {}) => {
  const lines = [];
  const add = (value) => {
    const text = String(value || '').trim();
    if (text && !lines.includes(text)) lines.push(text);
  };
  add(address.name);
  add(address.addr1 || address.address1);
  add(address.addr2 || address.address2);
  add([address.city, address.state, address.zip].filter(Boolean).join(' '));
  add(address.phone ? `Phone ${address.phone}` : '');
  add(address.website);
  add(address.email);
  return lines;
};

export const businessAddressTemplateValues = (address = {}) => ({
  company: address.name || '',
  address_line: address.addr1 || address.address1 || '',
  city: address.city || '',
  state: address.state || '',
  zip: address.zip || '',
  phone: address.phone || '',
});
